import { combineReducers } from 'redux';

import errorReducer from './error.reducer';
import globalStateReducer from './globalState.reducer';
import onlineStateReducer from './online.reducer';
import profileStateReducer from './profile.reducer';
import callStateReducer from './call.reducer';
import livemonitorReducer from './livemonitor.reducer';

export {
  errorReducer,
  globalStateReducer,
  onlineStateReducer,
  profileStateReducer,
  livemonitorReducer,
  callStateReducer
};

export default combineReducers({
  errorReducer,
  globalStateReducer,
  onlineStateReducer,
  profileStateReducer,
  livemonitorReducer,
  callStateReducer
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js